import React, { useState } from 'react';
import { motion, AnimatePresence, LayoutGroup } from 'framer-motion';
import { UserPlusIcon, UserMinusIcon } from 'lucide-react';
import { OnboardingWizard } from './pages/OnboardingWizard';
export function App() {
  const [mode, setMode] = useState<'onboarding' | 'offboarding' | null>(null);
  return <LayoutGroup data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        {mode === null ? <motion.div key="splash" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0,
        transition: {
          duration: 0.3
        }
      }} className="min-h-screen w-full bg-[#F0F2F5] flex flex-col items-center justify-center p-4 font-sans" data-id="element-2">
            <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="text-center mb-12" data-id="element-3">
              <img src="https://cdn.magicpatterns.com/uploads/kmdDfAkePYiLdiWNbyTETK/2026_Large_Transparent_New_Logo_-_Use_this_Always.png" alt="Rapid Home Lending" className="h-48 mx-auto mb-4" data-id="element-4" />
              <h1 className="text-xl font-medium text-gray-500 tracking-wide" data-id="element-5">
                User Management Console
              </h1>
            </motion.div>

            <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6" data-id="element-6">
              <motion.button layoutId="onboarding-toggle" onClick={() => setMode('onboarding')} className="flex items-center justify-center w-full sm:w-56 py-4 px-6 bg-[#2563EB] text-white rounded-xl shadow-lg hover:bg-[#1D4ED8] hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200 group" data-id="element-7">
                <UserPlusIcon className="w-5 h-5 mr-3 group-hover:scale-110 transition-transform" data-id="element-8" />
                <span className="text-base font-semibold" data-id="element-9">Onboarding</span>
              </motion.button>

              <motion.button layoutId="offboarding-toggle" onClick={() => setMode('offboarding')} className="flex items-center justify-center w-full sm:w-56 py-4 px-6 bg-white text-gray-700 border border-gray-200 rounded-xl shadow-sm hover:bg-gray-50 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 group" data-id="element-10">
                <UserMinusIcon className="w-5 h-5 mr-3 text-gray-500 group-hover:scale-110 transition-transform" data-id="element-11" />
                <span className="text-base font-semibold" data-id="element-12">Offboarding</span>
              </motion.button>
            </motion.div>
          </motion.div> : <motion.div key="wizard" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} className="w-full" data-id="element-13">
            <OnboardingWizard mode={mode} setMode={setMode} data-id="element-14" />
          </motion.div>}
      </AnimatePresence>
    </LayoutGroup>;
}